export default [
  {
    "lenderGuid": "d6453d7f-0ac7-4759-aceb-7da38f10f726",
    "lenderLogo": "//static.frekl.it/100/https://static.choosewisely.co.uk/entities/images/satsuma-monthly-this.png"
  },
  {
    "lenderGuid": "add00827-c0ba-490b-80d5-586dcdcbfc8e",
    "lenderLogo": "//static.frekl.it/100/http://ventura.rationetwork.co.uk/assets/upload/entity/9a2e7c83-71a3-4004-a32c-f4f4e5b844a6.png"
  },
  {
    "lenderGuid": "e354a1d9-490f-4407-b9d1-d9fcdc2147af",
    "lenderLogo": "//static.frekl.it/100/100/https://assets.choosewisely.co.uk/logo/entity/piggy-bank-loans-1.png"
  },
  {
    "lenderGuid": "6029042f-b48b-4ba7-93bb-bcff76e32e5b",
    "lenderLogo": "//static.frekl.it/100/http://ventura.rationetwork.co.uk/assets/upload/entity/b1d0eaa5-0f02-4472-ae72-29b47ab6fdd6.png"
  },
  {
    "lenderGuid": "ccdc4b82-3086-43d7-b0cc-68296bcc6292",
    "lenderLogo": "//static.frekl.it/100/http://ventura.rationetwork.co.uk/assets/upload/entity/dfc157ce-39f5-424c-97eb-469977a94687.png"
  },
  {
    "lenderGuid": "d512dd5f-8373-463a-8910-8cf2d8ac4455",
    "lenderLogo": "//static.frekl.it/100/http://ventura.rationetwork.co.uk/assets/upload/entity/eab48d87-dac4-45a6-81cb-91b09e79f478.png"
  },
  {
    "lenderGuid": "acb53558-2019-4178-b679-14a467567263",
    "lenderLogo": "https://static.frekl.it/100/http://ventura.rationetwork.co.uk/assets/upload/entity/74f54eff-64a5-4971-a49a-3c9dc45c6c85.png"
  },
  {
    "lenderGuid": "9b8bb4cf-4401-4049-961b-7cf91593efc6",
    "lenderLogo": "//static.frekl.it/100/100/http://ventura.rationetwork.co.uk/assets/upload/entity/452e660b-0e6d-48f0-b28c-d4ada016a223.png"
  },
  {
    "lenderGuid": "6ce3653a-5beb-4ed8-8707-23d4cf474f3e",
    "lenderLogo": "//static.frekl.it/100/100/https://assets.choosewisely.co.uk/logo/entity/aa57d86c-3685-42f0-acf2-39e7ca5174bf.png"
  },
  {
    "lenderGuid": "289f9d63-9bb9-467d-93f1-aa059bdfc815",
    "lenderLogo": "//static.frekl.it/100/100/https://assets.choosewisely.co.uk/logo/entity/likely-loans-logo.png"
  },
  {
    "lenderGuid": "1a89aae7-db2c-4ac6-bd60-002d0fc9b66a",
    "lenderLogo": "//static.frekl.it/100/100/https://assets.choosewisely.co.uk/logo/entity/6f94d98b-e6aa-4d44-9fa1-b3f5909dde5e.jpg"
  },
  {
    "lenderGuid": "4fa44bf6-3fb5-4199-bacc-31fd17513b76",
    "lenderLogo": "//static.frekl.it/100/100/https://assets.choosewisely.co.uk/logo/entity/caa050a0-74c3-4053-ad9b-a1710a6b20a6.png"
  },
  {
    "lenderGuid": "2764a237-bb6b-494c-8460-b088eb2964d2",
    "lenderLogo": "//static.frekl.it/100/100/https://assets.choosewisely.co.uk/logo/entity/d4cd0c59-b28e-47c0-986a-1f2039c120de.png"
  },
  {
    "lenderGuid": "f03c727b-b772-470d-b472-e059f7fa477e",
    "lenderLogo": "//static.frekl.it/100/https://assets.choosewisely.co.uk/logo/entity/0e72cb51-a987-48ee-8a55-82a012619c89.png?1516614466462"
  },
  {
    "lenderGuid": "74bef0fa-aa58-47f5-8d13-a24c80e97159",
    "lenderLogo": "//static.frekl.it/100/100/https://static.choosewisely.co.uk/entities/images/moneyplat.jpg"
  },
  {
    "lenderGuid": "4019d5fa-bdf0-4a61-b23d-f0ebb0016789",
    "lenderLogo": "//static.frekl.it/300/https://assets.choosewisely.co.uk/logo/entity/TrustedQuid.jpg"
  },
  {
    "lenderGuid": "d18b8850-0b4d-11e8-b137-379edf700c3d",
    "lenderLogo": "//static.frekl.it/100/https://assets.choosewisely.co.uk/logo/entity/Evolutionmoney.png"
  },
]


// WEBPACK FOOTER //
// ./src/lenderLogos.js